// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__QLFQL","inputWrap":"Table_inputWrap__1f7S3","col":"Table_col__30KjZ","bmiTooltip":"Table_bmiTooltip__F0U2K"};